import React from 'react';
import { StoryCard } from '../StoryCard';

class ThisOrThatCard extends StoryCard {
	render() {
		return <div className="this-or-that-card">{super.renderCard()}</div>;
	}
}

export default ThisOrThatCard;
